import { render, staticRenderFns } from "./holidayName.vue?vue&type=template&id=aa49257c"
import script from "./holidayName.vue?vue&type=script&lang=js"
export * from "./holidayName.vue?vue&type=script&lang=js"
import style0 from "./holidayName.vue?vue&type=style&index=0&id=aa49257c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports